import { Link } from "react-router-dom";

const services = [
  {
    icon: "ri-mental-health-line",
    title: "Individual Counseling",
    description: "One-on-one sessions tailored to your unique needs. A confidential space to explore your thoughts, feelings, and patterns at your own pace.",
    color: "bg-[#e6f6f5]",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "Anxiety & Stress",
    description: "Learn practical tools to quiet the noise, manage overwhelm, and reconnect with a sense of calm — even when life feels out of control.",
    color: "bg-[#eaf7f9]",
  },
  {
    icon: "ri-compass-3-line",
    title: "Life Transitions",
    description: "Career changes, loss, new chapters — transitions can feel destabilizing. We help you find your footing and move forward with confidence.",
    color: "bg-[#f0f9f9]",
  },
  {
    icon: "ri-team-line",
    title: "Relationship Support",
    description: "Whether it's communication, boundaries, or navigating conflict — we help you build healthier, more fulfilling connections.",
    color: "bg-[#e6f4f6]",
  },
];

export default function ServicesOverview() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-14 gap-6">
          <div>
            <p className="text-[#9a9a9a] text-xs font-medium tracking-widest uppercase mb-3">What We Offer</p>
            <h2 className="text-3xl md:text-5xl font-bold text-[#2d2d2d] leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Therapy Tailored<br />To Your Life.
            </h2>
          </div>
          <p className="text-[#6b6b6b] text-sm leading-relaxed max-w-sm">
            Every person's journey is different. Our services are designed to meet you exactly where you are.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((service) => (
            <div
              key={service.title}
              className={`${service.color} rounded-2xl p-7 flex flex-col gap-4 hover:-translate-y-1 transition-transform duration-300 cursor-default`}
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-white/70">
                <i className={`${service.icon} text-[#4db8b1] text-xl`}></i>
              </div>
              <h3 className="text-[#2d2d2d] font-semibold text-base" style={{ fontFamily: "'Playfair Display', serif" }}>
                {service.title}
              </h3>
              <p className="text-[#6b6b6b] text-sm leading-relaxed flex-1">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 border border-[#4db8b1] text-[#418b86] hover:bg-[#4db8b1] hover:text-white font-medium px-7 py-3 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
          >
            Explore All Services
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
